module.exports = __webpack_public_path__ + "img/gallery_gray.f4a088ad.svg";